import { useEffect, useRef, useState } from 'react';
import ChatUI from './ChatUI';
import { useUserStore } from '../../stores/user-store';
import {
    CreateNewChatSession,
    GetChatSessionDetails,
    GetChatSessionListByUser,
    SendMessage
} from '../../models/chats';
import { pnkstore } from '../../stores/pnk-store';
import { Box } from '@mui/material';

export default function ChatCtrl() {
    const userData = useUserStore.getState();

    const [chatSessionSearchObj, setChatSessionSearchObj] = useState({});
    const [getChatSessionList, setGetChatSessionList] = useState(false);
    const [ChatSessionList, setChatSessionList] = useState([]);

    const [CreateChatSessionObj, setCreateChatSessionObj] = useState({});
    const [newChatSession, setNewChatSession] = useState(false);

    const [SendNewMessage, setSendNewMessage] = useState(false);
    const [NewMessageObj, setNewMessageObj] = useState({});

    const [getChatSessionDetails, setGetChatSessionDetails] = useState(false);

    const [chats, setChats] = useState([]);
    const [chatTypeEffect, setChatTypeEffect] = useState(false);

    const [activeChatId, setActiveChatId] = useState('');
    const [input, setInput] = useState('');
    const [loading, setLoading] = useState(false);
    const [showPauseButton, setShowPauseButton] = useState(false);

    const activeChat = ChatSessionList.find(c => c._id === activeChatId);

    const bottomRef = useRef(null);

    const scrollToBottom = () => {
        bottomRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    /* ======================================================
       INITIAL LOAD
    ====================================================== */

    const ResetChatTypeEffect = () => {
        setChatTypeEffect(false);
        TogglePauseButton();
        scrollToBottom();
    }

    useEffect(() => {
        setChatSessionSearchObj({ txtUserName: userData.username });
        setGetChatSessionList(true);
    }, []);

    /* ======================================================
       CHAT SESSION LIST
    ====================================================== */

    const ChatSessionListResponse = (res) => {
        setGetChatSessionList(false);
        if (res !== false) {
            setActiveChatId(res.data.chatsessionlistresponse.message.value[0]._id);
            setChatSessionList(res.data.chatsessionlistresponse.message.value);
            setChatSessionSearchObj({
                txtUserName: userData.username,
                sessionId: res.data.chatsessionlistresponse.message.value[0]._id
            });
            setGetChatSessionDetails(true);
        } else {
            setChatSessionList([]);
        }
    };

    /* ======================================================
       CREATE NEW CHAT
    ====================================================== */

    const createNewChat = () => {
        setCreateChatSessionObj({
            txtUserName: userData.username,
            txtUserProfile: userData.profile
        });
        setNewChatSession(true);
    };

    const NewChatSessionResponse = (res) => {
        setNewChatSession(false);

        if (res !== false) {
            setChatSessionSearchObj({ txtUserName: userData.username });
            setGetChatSessionList(true);
        }
    };

    /* ======================================================
       SEND MESSAGE
    ====================================================== */

    const sendMessage = () => {
        if (!input.trim()) return;

        const userMsg = { role: 'user', text: input };

        setChats(prev => [...prev, userMsg]); // ✅ FIXED (no mutation)
        setInput('');
        setLoading(true);
        TogglePauseButton();
        setChatTypeEffect(true);

        setNewMessageObj({
            sessionId: activeChatId,
            question: input
        });

        setSendNewMessage(true);
    };

    const NewMessageResponse = (res) => {
        setSendNewMessage(false);

        let reply = 'No Project Found';

        if (res !== false) {
            console.log(res);
            if (res.data.PinakaResponse.FailureReason !== undefined) {
                reply = res.data.PinakaResponse.FailureReason
                TogglePauseButton();
            }
            else {
                reply = JSON.stringify(
                    res.data.chatresponse.message.value[0].projects
                );
            }
        }


        const assistantMsg = { role: 'assistant', text: reply };

        setChats(prev => [...prev, assistantMsg]); // ✅ FIXED
        setLoading(false);
    };

    /* ======================================================
       LOAD CHAT HISTORY
    ====================================================== */

    const GetChatSessionData = (chatSessionId) => {
        setActiveChatId(chatSessionId);
        setChatTypeEffect(false); // ❗ history should NOT type

        setChatSessionSearchObj({
            txtUserName: userData.username,
            sessionId: chatSessionId
        });

        setGetChatSessionDetails(true);
    };

    const ChatSessionDetailsResponse = (res) => {
        setGetChatSessionDetails(false);

        if (res !== false) {
            const data = res.data.chathistoryresponse.message.value;

            const chatArray = data.map(item =>
                item.role === 'user'
                    ? { role: 'user', text: item.message }
                    : { role: 'assistant', text: JSON.stringify(item.data) }
            );

            setChats(chatArray);
        } else {
            setChats([]);
        }
    };


    const TogglePauseButton = () => {
        if (showPauseButton) {
            setShowPauseButton(false)
        }
        else {
            setShowPauseButton(true);
        }
    }


    const QuickSearch = (quick_text) => {
       // alert(quick_text);
        const userMsg = { role: 'user', text: quick_text };

        setChats(prev => [...prev, userMsg]); // ✅ FIXED (no mutation)
        setInput('');
        setLoading(true);
        TogglePauseButton();
        setChatTypeEffect(true);

        setNewMessageObj({
            sessionId: activeChatId,
            question: quick_text
        });

        setSendNewMessage(true);
    }

    /* ======================================================
       RENDER
    ====================================================== */

    return (
        <Box>
            <ChatUI
                chats={chats}
                activeChat={activeChat}
                input={input}
                loading={loading}
                ChatSessionList={ChatSessionList}
                activeChatId={activeChatId}
                onInputChange={setInput}
                onSend={sendMessage}
                onNewChat={createNewChat}
                onSelectChat={GetChatSessionData}
                chatTypeEffect={chatTypeEffect}
                showPauseButton={showPauseButton}
                TogglePauseButton={TogglePauseButton}
                ResetChatTypeEffect={ResetChatTypeEffect}
                QuickSearch={QuickSearch}
            />

            {getChatSessionList &&
                GetChatSessionListByUser(
                    pnkstore,
                    chatSessionSearchObj,
                    ChatSessionListResponse
                )}

            {SendNewMessage &&
                SendMessage(
                    pnkstore,
                    NewMessageObj,
                    NewMessageResponse
                )}

            {newChatSession &&
                CreateNewChatSession(
                    pnkstore,
                    CreateChatSessionObj,
                    NewChatSessionResponse
                )}

            {getChatSessionDetails &&
                GetChatSessionDetails(
                    pnkstore,
                    chatSessionSearchObj,
                    ChatSessionDetailsResponse
                )}
        </Box>
    );
}
